import './style.css';

const Turismo = ({ descricao, banner, link }) => {
    // Valida se o banner tem um nome de arquivo válido
    const bannerValido = banner && banner !== '' && !banner.endsWith('/');
    
    return (
      <div className="turismo-card">
        {bannerValido && (
          <div className="turismo-image-wrapper">
            <img src={banner} alt={descricao} className="turismo-img" />
          </div>
        )}
        <div className="turismo-info">
          <h3 className="turismo-title">{descricao}</h3>
          <div className="turismo-actions">
            { link && (
              <a href={link} target="_blank" rel="noopener noreferrer" className="turismo-btn">
                Saiba mais <i className="fas fa-external-link-alt"></i>
              </a>
            )}
          </div>
        </div>
      </div>
    );
  };
  
  export default Turismo;